import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Queries } from '@api/graphql/queries';
import { PendencyType } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import { searchManyInputStyles } from '../../base/fc-search-many-input/fc-search-many-input.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'fc-pendency-types-input',
  templateUrl: './fc-pendency-types-input.component.html',
  styleUrls: ['./fc-pendency-types-input.component.scss']
})
export class FcPendencyTypesInputComponent {

  @Input()
  public control: FormControl;

  @Input()
  public shouldDisplayArchived = false;

  @Input()
  public desiredStyle: searchManyInputStyles = searchManyInputStyles.Select;

  @Input()
  public disabled = false;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private apollo: Apollo,
    private queries: Queries
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  async search(searchTerm: string, limit: number, offset: number): Promise<PendencyType[]> {
    const where = {
      nameContains: searchTerm,
    };

    if (!this.shouldDisplayArchived) {
      where['archived'] = false;
    }

    return this.apollo
      .query({
        query: this.queries.searchPendencyTypes(),
        variables: {
          where,
          limit: limit,
          offset: offset
        },
      })
      .toPromise()
      .then((result) => result.data['pendencyTypes']['items'])
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  displayWith(value: PendencyType): string {
    return value && value.name;
  }
}
